import { commaFormating } from "../../Utility/modules/helpers";
export const columns = [
  {
    label: "Flowstation",
    value: "Flowstation",
  },

  {
    label: "Field",

    value: "Field",
  },
  { label: "Well", value: "Well" },
  {
    label: "Level",

    value: "Level",
  },
  {
    label: "UniqueId",

    value: "UniqueId",
  },
  {
    value: "Production_Year",
    label: "Production Year",
  },
  {
    value: "Production_Month",
    label: "Production Month",
  },
  {
    value: "Production_Month_Name",
    label: "Production Month Name",
  },

  {
    label: "Choke",
    value: "Choke",
  },
  {
    label: "Days Produced",
    value: "Days_Produced",
  },
  {
    label: "FTHP",
    value: "FTHP",
  },
  {
    label: "BSW",
    value: "BSW",
  },
  {
    label: "API",
    value: "API",
  },
  {
    label: "Initial GOR",
    value: "Initial_GOR",
  },
  {
    label: "Producing GOR",
    value: "Producing_GOR",
  },
  {
    label: "Oil Volume",
    value: "Oil_Volume",
  },

  {
    label: "Gas Volume",
    value: "Gas_Volume",
  },
  {
    label: "Water Volume",
    value: "Water_Volume",
  },
  {
    label: "Oil Rate",
    value: "Oil_Rate",
  },
  {
    label: "Gas Rate",
    value: "Gas_Rate",
  },
  {
    label: "Type",
    value: "Type",
  },
  {
    label: "Last Date Produced",
    value: "Last_Date_Produced",
  },
  {
    label: "Month Produced",
    value: "Month_Produced",
  },
  {
    label: "Oil Cummulatives",
    value: "Oil_Cummulative",
  },
  {
    label: "Gas Cummulatives",
    value: "Gas_Cummulative",
  },
  {
    label: "Water Cummulatives",
    value: "Water_Cummulative",
  },
  {
    label: "Flowstation Status",
    value: "Flowstation_Status",
  },
  {
    label: "Field Status",
    value: "Field_Status",
  },
  {
    label: "Remarks",
    value: "Remarks",
  },
];

export const gridColums = [
  {
    headerName: "#",
    valueGetter: "node.rowIndex + 1",
    width: 50,
    resizable: true,
    sortable: true,
    pivot: false,
    field: "#",
  },
  {
    width: 80,
    checkboxSelection: true,
    pivot: false,
    field: "check",
    filter: true,
  },
  {
    headerName: "Flowstation",

    field: "flowstation",

    sortable: true,
    resizable: true,
    filter: true,
    chartDataType: "category",

    width: 120,
  },
  {
    headerName: "Field",

    field: "field",

    sortable: true,
    resizable: true,
    filter: true,
    chartDataType: "category",

    width: 100,
  },
  {
    headerName: "Well",
    field: "well",
    sortable: true,
    resizable: true,
    filter: true,

    width: 100,
  },
  {
    headerName: "Level",

    field: "level",

    sortable: true,
    resizable: true,
    filter: true,

    width: 100,
  },
  {
    headerName: "UniqueId",

    field: "uniqueId",
    sortable: true,
    resizable: true,
    filter: true,

    width: 100,
  },
  {
    field: "production_Year",
    headerName: "Production Year",

    sortable: true,
    resizable: true,
    filter: true,

    width: 150,
  },
  {
    field: "production_Month",
    headerName: "Production Month",
    type: "numberColumn",
    sortable: true,
    resizable: true,
    filter: true,

    width: 170,
  },
  {
    field: "production_Month_Name",
    headerName: "Production Month Name",
    sortable: true,
    resizable: true,
    filter: true,

    width: 170,
  },

  {
    headerName: "Choke",
    field: "choke",

    sortable: true,
    resizable: true,
    filter: true,

    width: 100,
  },
  {
    headerName: "Days Produced",
    field: "days_Produced",
    type: "numberColumn",
    sortable: true,
    resizable: true,
    filter: true,

    width: 100,
  },
  {
    headerName: "FTHP",
    field: "fthp",

    sortable: true,
    resizable: true,
    filter: true,

    width: 100,
  },
  {
    headerName: "BSW",
    field: "bsw",

    sortable: true,
    resizable: true,
    filter: true,

    width: 100,
  },
  {
    headerName: "API",
    field: "api",

    sortable: true,
    resizable: true,
    filter: true,

    width: 100,
  },
  {
    headerName: "Initial GOR",
    field: "initial_GOR",

    sortable: true,
    resizable: true,
    filter: true,

    width: 100,
  },
  {
    headerName: "Producing GOR",
    field: "producing_GOR",

    sortable: true,
    resizable: true,
    filter: true,

    width: 100,
  },
  {
    headerName: "Oil Volume (bbl)",
    field: "oil_Volume",
    sortable: true,
    resizable: true,
    filter: true,
    cellStyle: { textAlign: "right", backgroundColor: "#ff6b7a" },
    width: 170,
    type: "numberColumn",
    chartDataType: "series",
    valueFormatter: commaFormating,
  },

  {
    headerName: "Gas Volume(Mscf)",
    field: "gas_Volume",
    sortable: true,
    resizable: true,
    filter: true,
    cellStyle: { textAlign: "right", backgroundColor: "#31e464" },
    width: 170,
    type: "numberColumn",
    valueFormatter: commaFormating,
  },
  {
    headerName: "Water Volume (bbl)",
    field: "water_Volume",
    sortable: true,
    resizable: true,
    filter: true,
    cellStyle: { textAlign: "right", backgroundColor: "#FFECB3" },
    width: 170,
    type: "numberColumn",
    valueFormatter: commaFormating,
  },
  {
    headerName: "Oil Rate (stb/d)",
    field: "oil_Rate",
    sortable: true,
    resizable: true,
    filter: true,
    cellStyle: { textAlign: "right", backgroundColor: "#ffcdd2 " },
    width: 170,
    type: "numberColumn",
  },
  {
    headerName: "Gas Rate(Mscf/d)",
    field: "gas_Rate",
    sortable: true,
    resizable: true,
    filter: true,
    cellStyle: { textAlign: "right", backgroundColor: "#B9F6CA" },
    width: 170,
    type: "numberColumn",
  },
  {
    headerName: "Type",
    field: "type",

    sortable: true,
    resizable: true,
    filter: true,

    width: 100,
  },
  {
    headerName: "Last Date Produced",
    field: "last_Date_Produced",

    sortable: true,
    resizable: true,
    filter: true,

    width: 100,
  },
  {
    headerName: "Months Produced",
    field: "month_Produced",

    sortable: true,
    resizable: true,
    filter: true,

    width: 100,
  },
  {
    headerName: "Oil Cummulatives (bbl)",
    field: "oil_Cummulative",
    sortable: true,
    resizable: true,
    filter: true,
    cellStyle: { textAlign: "right", backgroundColor: "lightblue" },
    width: 170,
    type: "numberColumn",
    valueFormatter: commaFormating,
  },

  {
    headerName: "Gas Cummulatives (Mscf)",
    field: "gas_Cummulative",
    sortable: true,
    resizable: true,
    filter: true,
    cellStyle: { textAlign: "right", backgroundColor: "lightblue" },
    width: 170,
    type: "numberColumn",
    valueFormatter: commaFormating,
  },
  {
    headerName: "Water Cummulatives (bbl)",
    field: "water_Cummulative",
    sortable: true,
    resizable: true,
    filter: true,
    cellStyle: { textAlign: "right", backgroundColor: "lightblue" },
    width: 170,
    type: "numberColumn",
    valueFormatter: commaFormating,
  },
  {
    headerName: "Flowstation Status",
    field: "flowstation_Status",

    sortable: true,
    resizable: true,
    filter: true,

    width: 100,
  },
  {
    headerName: "Field Status",
    field: "field_Status",

    sortable: true,
    resizable: true,
    filter: true,

    width: 100,
  },

  {
    headerName: "Remarks",
    field: "remarks",

    sortable: true,
    resizable: true,
    filter: true,

    width: 100,
  },
];

